function getBrowser() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // Check for iOS WebView
  const isIOSWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
    userAgent
  );
  if (isIOSWebView) {
    return false;
  }

  // Check for Android WebView
  const isAndroidWebView =
    /; wv\)/i.test(userAgent) ||
    /Version\/[\d.]+.*Chrome\/[\d.]+ Mobile Safari\/[\d.]+/i.test(userAgent);
  if (isAndroidWebView) {
    return false;
  }
  return true;
}

export function isMobile() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  let browser = getBrowser();
  return !browser;
}
